<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilterCollectiveActive">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterFormCollectiveActive"
                    aria-controls="filterFormCollectiveActive">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterFormCollectiveActive" class="collapse" aria-labelledby="filterFormCollectiveActive" data-parent="#userFilterCollectiveActive">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                    <kt-form-section >
                        <kt-form-row>
                            <kt-col xs="12" sm="4" md="4">
                                <kt-form-group>
                                    <kt-form-label for="full_name">
                                        {{ $t('label.user_full_name') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            ref="full_name"
                                            dir="ltr"
                                            name="full_name"
                                            id="full_name"
                                            v-model="query.full_name"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="4" md="4">
                                <kt-form-group>
                                    <kt-form-label for="title">
                                        {{ $t('label.gateway_title') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        ref="title"
                                        name="title"
                                        id="title"
                                        v-model="query.title"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="4" md="4">
                                <kt-form-group>
                                    <kt-form-label for="gateway_category">
                                        {{ $t('label.cat_name') }}
                                    </kt-form-label>
                                    <select
                                            id="gateway_category"
                                            name="gateway_category"
                                            v-model="query.dedicated_category_ids"
                                            class="form-control kt-selectpicker"
                                            multiple
                                    >
                                        <option value="">
                                        </option>
                                        <option
                                                v-bind:key="category.id"
                                                v-for="category in dedicated_categories"

                                                :value="category.id"
                                        >
                                            {{ category.title }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>
                    <kt-form-section>
                        <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                    </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import $ from "jquery";
import { i18n } from '@/plugins/i18n'
import {mapGetters} from "vuex";
import {dedicatedService} from "@/common/api.service";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    mounted() {
        this.getCategoriesForSelect()
    },

    methods: {
        afterDispatch() {
          setTimeout(function () {
            $('.kt-selectpicker').selectpicker({
              size: 4,
              liveSearch: true,
              noneResultsText: i18n.t('selectpicker.none_result'),
              selectAllText: i18n.t('selectpicker.select_all'),
              noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
          }, 2000)
        },
        getCategoriesForSelect(){
            dedicatedService.fetchCategoriesForSelect(this.is_starshop)
                .then((response) => {
                  this.dedicated_categories = response.data.data;
                  this.afterDispatch()
                })
        },
    },
    data() {
        return {
            query: {
                dedicated_category_ids: [],
            },
            dedicated_categories: [],
            is_starshop: true
        }
    }
}
</script>

<style>

</style>